import React from 'react';
import { Mutation } from '../../reactApolloCompat';
import gql from 'graphql-tag';
import IconButton from '@mui/material/IconButton';
import Grid from '../layout/Grid';
import DeleteIcon from '../icon/DeleteIcon';
import PhoneSquareIcon from '../icon/PhoneSquareIcon';
import EnvelopeSquareIcon from '../icon/EnvelopeSquareIcon';
import FaxIcon from '../icon/FaxIcon';
import MobileIcon from '../icon/MobileIcon';
import Inline, { inlineAlignment } from '../layout/Inline';
import FlexGrid from '../layout/FlexGrid';
import { prettyEmail, prettyPhone, stringIsNullOrEmpty } from '../../utils/strings';
import GatedComponent from '../GatedComponent';

class UserCard extends React.Component {
    state = {
        item: null
    };

    static getDerivedStateFromProps({ contact }, { item }) {
        if (contact && (!item || contact.ID !== item.ID)) {
            return { item: { ...contact } };
        }

        return null;
    }

    render() {
        const { variant, contact, readOnly = false } = this.props;
        if (!contact) return null;
        let cssVariant = null;
        if (!stringIsNullOrEmpty(variant)) cssVariant = `contactcard--${variant}`;

        const { item } = this.state;
        const parentGroup = item.Groups.find(obj => obj.Code === 'cm-users');
        const groups = item.Groups.filter(obj => obj.ParentID === parentGroup.ID);

        const { mutation, variables } = this.getRetirementMutation();

        return (
            <div className={`contactcard ${cssVariant || ''}`}
                 style={{ backgroundColor: item.Deactivated ? '#FFFFFF99' : null }}>
                <Grid container spacing={2}>
                    <Grid item>
                        <GatedComponent canViewCode="ADMIN">
                            {() => {
                                return (
                                    <Mutation
                                        mutation={mutation}
                                        onCompleted={this.updateContact}
                                        onError={e => this.handleMutateError(e)}
                                    >
                                        {(mutate, { loading }) => {
                                            const disabled = loading || readOnly;
                                            return (
                                                <IconButton
                                                    style={{
                                                        transform: item.Deactivated ? 'rotate(180deg)' : null,
                                                        position: 'absolute',
                                                        top: 3,
                                                        right: 3,
                                                        zoom: 0.75
                                                    }}
                                                    aria-label="Delete"
                                                    className="icon"
                                                    title={item.Deactivated ? 'Restore' : 'Retire'}
                                                    disabled={disabled}
                                                    onClick={e =>
                                                        this.onDeleteClicked(mutate, !disabled && variables, e)
                                                    } size="large">
                                                    <DeleteIcon />
                                                </IconButton>
                                            );
                                        }}
                                    </Mutation>
                                );
                            }}
                        </GatedComponent>
                        <p className="contact-name">{item.FirstName} {item.MiddleName} {item.Surname}</p>
                        {(!!item.Surname || !!item.AddressBookCategory) && <Inline center>
                            {!!groups.length && groups.map(obj =>
                                <p className="business-category" key={obj.ID}>{obj.Title}</p>)}
                        </Inline>}
                    </Grid>


                    {item.Phone && (
                        <FlexGrid variant="justify">
                            <Inline center nowrap className="contact-info">
                                <PhoneSquareIcon className="contact-icon" />
                                <p className="contact-details">{prettyPhone(item.Phone)}</p>
                            </Inline>
                        </FlexGrid>
                    )}
                    {item.Mobile && (
                        <FlexGrid variant="justify">
                            <Inline center nowrap className="contact-info">
                                <MobileIcon className="contact-icon" />
                                <p className="contact-details">{prettyPhone(item.Mobile)}</p>
                            </Inline>
                        </FlexGrid>
                    )}
                    {item.Fax && (
                        <FlexGrid variant="justify">
                            <Inline center nowrap className="contact-info">
                                <FaxIcon className="contact-icon" />
                                <p className="contact-details">{prettyPhone(item.Fax)}</p>
                            </Inline>
                        </FlexGrid>
                    )}
                    {item.Email && (item.Email).includes('@') && (
                        <FlexGrid variant="justify">
                            <Inline center nowrap className="contact-info">
                                <EnvelopeSquareIcon className="contact-icon" />
                                <p className="contact-details">{prettyEmail(item.Email)}</p>
                            </Inline>
                        </FlexGrid>
                    )}
                </Grid>
                <Grid container spacing={2}>
                    <Grid item>
                        <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                            <div />
                            {/* TODO: add some actions here */}
                            &nbsp;
                        </Inline>
                    </Grid>
                </Grid>
            </div>
        );
    }

    onDeleteClicked = (mutate, variables, e) => {
        e.preventDefault();
        let msg = 'You\'re about to retire this user.\nAre you sure?';
        if (!variables.input.Deactivated) msg = 'You\'re about to restore this user.\nAre you sure?';
        const axe = window.confirm(msg);
        if (axe) {
            if (variables) mutate({ variables });
        }
    };

    updateContact = ({ updateMember: newData }) => {
        const { item } = this.state;
        const { onUpdate } = this.props;
        this.setState({ item: { ...item, ...newData } }, () => onUpdate && onUpdate());
    };

    getRetirementMutation() {
        const { item } = this.state;
        return {
            mutation: gql`
                mutation RetireUser($input: UpdateMemberInput!) {
                    updateMember(input: $input) {
                        ID
                        Deactivated
                    }
                }
            `,
            variables: {
                input: { Deactivated: !item.Deactivated, ID: item.ID }
            }
        };
    }
}

export default UserCard;
